import { useEffect } from "react";
import type { CityConfig } from "@/pages/city-template/types";
import CityHeroSection from "@/pages/city-template/components/CityHeroSection";
import CityStickyNav from "@/pages/city-template/components/CityStickyNav";
import CityProcessingTimeSection from "@/pages/city-template/components/CityProcessingTimeSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityFAQSection from "@/pages/city-template/components/CityFAQSection";
import OregonCityHelpfulResourcesSection from "./components/OregonCityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import useCitySEO from "@/pages/city-template/components/CitySEO";

export default function OregonCityPageTemplate({ config }: { config: CityConfig }) {
  useCitySEO(config);

  return (
    <div className="font-sans">
      <CityHeroSection
        city={config.city}
        h1={config.h1}
        subtitle={config.heroSubtitle}
        imageUrl={config.heroImageUrl}
        imageAlt={config.heroImageAlt}
      />
      <CityStickyNav links={config.stickyNavLinks} />
      <CityProcessingTimeSection city={config.city} options={config.processingOptions} />
      <CityServicesSection city={config.city} services={config.services} />
      <CityLocalAreaSection
        city={config.city}
        state={config.state}
        cities={config.nearbyCitiesZips}
        benefits={config.benefits}
        internalLinks={config.internalLinks}
        officeNote={config.fpcOfficeNote}
        officeDistance={config.fpcOfficeDistance}
        serviceAreaIntro={config.serviceAreaIntro}
        nearbyCitiesIntro={config.nearbyCitiesIntro}
      />
      <CityTestimonialsSection city={config.city} testimonials={config.testimonials} intro={config.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={config.city} facilities={config.facilities} />
      <CityComparisonSection city={config.city} regionalAgency={config.regionalAgency} rows={config.comparisonRows} />
      <CityMistakesSection city={config.city} mistakes={config.mistakes} intro={config.mistakesIntro} />
      <CityHowItWorksSection city={config.city} steps={config.steps} intro={config.howItWorksIntro} />
      <CityFAQSection city={config.city} faqs={config.faqs} intro={config.faqIntro} />
      <OregonCityHelpfulResourcesSection
        city={config.city}
        photoLocations={config.photoLocations}
        dmvLocations={config.dmvLocations}
        airports={config.airports}
      />
      <SEOCrossLinks currentRoute={config.route} state={config.stateAbbr} showCities={false} />
      <CityFinalCTA />
    </div>
  );
}